import * as Cookies from 'js-cookie/src/js.cookie.js';
import * as moment from 'vendors/moment-locale-th';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserModel } from '../../model/user.model';
import { ActHttpService, ContentTypes, HeaderTypes } from '../act-http/act-http.service';
import { ActToken } from '../authentication/authentication.service';
import { environment } from '../../../environments/environment';
import { Response } from '@angular/http';
import { LoginResponseModel } from '../../model/login/login-response.model';
import { AuthenticationService } from 'app/services/authentication/authentication.service';
import { PromotionCode } from '../checkout/payload/create-order.payload';
import { CampaignTrackEventRequest } from './payload/campaign.model';

@Injectable()
export class PromotionService {
  private readonly cookieName = 'stf';
  constructor(
    private actHttp: ActHttpService,
    private authService: AuthenticationService,
  ) { }

  saveTokenAfterLogin(loginResponse: LoginResponseModel) {
    if (loginResponse.token && loginResponse.user) {
      this.authService.savePromotionToken(loginResponse);
    }
  }

  verifyPromotionCode(code: String, destination: String, companyId: Number): Observable<any> {
    const payload = new PromotionCode();
    payload.code = code;
    payload.destination = destination;
    payload.companyId = companyId;
    const options = this.actHttp.getRequestOptions(HeaderTypes.AUTHORIZATION_RANDOM_STR, ContentTypes.JSON, JSON.stringify(payload));
    return this.actHttp.rawPost(
      environment.endpoint.validatePromotionCode,
      JSON.stringify(payload), options)
      .map((response: Response) => {
        const loginResponse: LoginResponseModel = response.json().data;
        this.saveTokenAfterLogin(loginResponse);
        return response.json();
      })
  }

  trackAdsEvent(campaignId: number, event: string) {
    const request = new CampaignTrackEventRequest(event);
    const url = environment.endpoint.campaignTracking.replace('{campaignId}', campaignId.toString());
    return this.actHttp.post(
      url,
      request,
      this.actHttp.getRequestOptions()
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion.service.ts